var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rooms"},[_vm._m(0),_c('GiftcardForm',{attrs:{"saving":_vm.saving,"error":_vm.error},on:{"save":_vm.save,"resetError":function($event){_vm.error=null}}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breadcrumbs"},[_c('h2',[_vm._v("Create a Gift Card")])])
}]

export { render, staticRenderFns }